'use client';

var daysInWeekEn = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
var daysInWeek = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
var months = [
    {
        name: 'Tháng 1',
        sortName: 'Th 1',
        nameEn: 'January',
        sortNameEn: 'Jan',
        id: 0
    },
    {
        nameEn: 'February',
        sortNameEn: 'Feb',
        name: 'Tháng 2',
        sortName: 'Th 2',
        id: 1
    },
    {
        nameEn: 'March',
        sortNameEn: 'Mar',
        name: 'Tháng 3',
        sortName: 'Th 3',
        id: 2
    },
    {
        nameEn: 'April',
        sortNameEn: 'Apr',
        name: 'Tháng 4',
        sortName: 'Th 4',
        id: 3
    },
    {
        nameEn: 'May',
        sortNameEn: 'May',
        name: 'Tháng 5',
        sortName: 'Th 5',
        id: 4
    },
    {
        nameEn: 'June',
        sortNameEn: 'Jun',
        name: 'Tháng 6',
        sortName: 'Th 6',
        id: 5
    },
    {
        nameEn: 'July',
        sortNameEn: 'Jul',
        name: 'Tháng 7',
        sortName: 'Th 7',
        id: 6
    },
    {
        nameEn: 'August',
        sortNameEn: 'Aug',
        name: 'Tháng 8',
        sortName: 'Th 8',
        id: 7
    },
    {
        nameEn: 'September',
        sortNameEn: 'Sep',
        name: 'Tháng 9',
        sortName: 'Th 9',
        id: 8
    },
    {
        nameEn: 'October',
        sortNameEn: 'Oct',
        name: 'Tháng 10',
        sortName: 'Th 10',
        id: 9
    },
    {
        nameEn: 'November',
        sortNameEn: 'Nov',
        name: 'Tháng 11',
        sortName: 'Th 11',
        id: 10
    },
    {
        nameEn: 'December',
        sortNameEn: 'Dec',
        name: 'Tháng 12',
        sortName: 'Th 12',
        id: 11
    }
];
var FIRST_MONTH = 0;
var FIRST_DAY = 1;
var LAST_DAY = 0;
var TODAY = new Date();

export { FIRST_DAY, FIRST_MONTH, LAST_DAY, TODAY, daysInWeek, daysInWeekEn, months };
//# sourceMappingURL=const.js.map
